'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "bounce"
    }, [_c('div', {
      staticClass: "bounce-slider",
      style: _vm.style,
      on: {
        "touchstart": _vm.onTouchStart,
        "touchmove": _vm.onTouchMove,
        "touchend": _vm.onTouchEnd,
        "touchcancel": _vm.onTouchEnd
      }
    }, [_vm._t("default")], 2)]);
  },
  staticRenderFns: [],
  name: 'bounce',
  props: {
    mode: {
      type: String,
      default: 'both'
    },
    distance: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      offset: 0,
      duration: 0,
      floor: false,
      startX: 0,
      startY: 0,
      deltaY: 0,
      ceiling: false,
      direction: ''
    };
  },
  computed: {
    style: function style() {
      return {
        transform: "translate3d(0, ".concat(this.offset, "px, 0)"),
        transition: "".concat(this.duration, "ms")
      };
    }
  },
  methods: {
    onTouchStart: function onTouchStart(event) {
      var root = document.documentElement;
      var scrollY = window.scrollY || window.pageYOffset;

      if (this.mode !== 'bottom') {
        this.ceiling = scrollY === 0;
      }

      if (this.mode !== 'top') {
        this.floor = root.offsetHeight <= scrollY + root.clientHeight;
      }

      if (this.ceiling || this.floor) {
        this.duration = 0;
      }

      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;
    },
    onTouchMove: function onTouchMove(event) {
      this.deltaY = event.touches[0].clientY - this.startY;
      this.direction = this.getDirection(event.touches[0]);

      if (this.ceiling && this.deltaY >= 0 || this.floor && this.deltaY <= 0) {
        if (this.direction === 'vertical') {
          event.preventDefault();
        }

        this.translate(this.deltaY);
      }
    },
    onTouchEnd: function onTouchEnd() {
      if ((this.ceiling || this.floor) && this.deltaY) {
        this.duration = 500;
        this.translate(0);
      }
    },
    getDirection: function getDirection(touch) {
      var distanceX = Math.abs(touch.clientX - this.startX);
      var distanceY = Math.abs(touch.clientY - this.startY);
      return distanceX > distanceY ? 'horizontal' : distanceX < distanceY ? 'vertical' : '';
    },
    translate: function translate(offset) {
      var sign = offset > 0 ? 1 : -1;
      offset = Math.abs(offset / (this.distance * 3));
      offset = this.easeOut(offset);
      offset = Math.round(offset * this.distance);
      this.offset = sign * offset;
    },
    easeOut: function easeOut(percent) {
      return percent >= 1 ? 1 : --percent * percent * percent + 1;
    }
  }
});

exports.default = index;
